export default __webpack_public_path__ + "static/media/people_type_couple.e5e79e0e.svg";